import { Controller } from "@hotwired/stimulus"

// Envía el formulario padre al elegir una opción (sin botón Guardar).
export default class extends Controller {
  submit() {
    const form = this.element.form
    if (!form || this.element.value === "") return

    form.requestSubmit()
  }
}
